export enum Role {
    ADMIN = 'ADMIN',
    PROCESS_ADMIN = 'PROCESS_ADMIN',
    MANAGER = 'MANAGER',
    READER = 'READER',
}
